import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { api } from '../../lib/api';

function formatDate(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch (_err) {
    return '';
  }
}

const STATUS_LABELS = {
  free: { label: 'Free', variant: 'secondary' },
  active: { label: 'Active', variant: 'success' },
  trialing: { label: 'Trial', variant: 'info' },
  past_due: { label: 'Past due', variant: 'warning' },
  canceled: { label: 'Cancelled', variant: 'danger' },
};

const SubscriptionSettings = ({ user, token, show, onHide, onUpgrade }) => {
  const status = user?.subscriptionStatus || 'free';
  const meta = STATUS_LABELS[status] || STATUS_LABELS.free;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleManage = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await api.openBillingPortal(token);
      if (result?.url) {
        window.location.href = result.url;
      } else {
        setError('No portal URL returned');
      }
    } catch (err) {
      setError(err?.message || 'Failed to open billing portal');
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? <Alert variant="danger">{error}</Alert> : null}
        <div className="mb-3">
          <strong>Status:</strong>{' '}
          <Badge bg={meta.variant} className="ms-1">{meta.label}</Badge>
        </div>
        {user?.subscriptionCurrentPeriodEnd ? (
          <div className="mb-3 text-muted small">
            {status === 'canceled'
              ? `Access ends ${formatDate(user.subscriptionCurrentPeriodEnd)}`
              : `Next renewal: ${formatDate(user.subscriptionCurrentPeriodEnd)}`}
          </div>
        ) : null}
        {user?.subscriptionCancelAt ? (
          <div className="mb-3 text-muted small">
            Cancels on {formatDate(user.subscriptionCancelAt)}
          </div>
        ) : null}
        <hr />
        {status === 'free' || status === 'canceled' ? (
          <Button variant="primary" onClick={onUpgrade} className="w-100">
            Upgrade to full access
          </Button>
        ) : null}
        {user?.hasStripeCustomer ? (
          <Button variant="outline-secondary" className="w-100 mt-2" onClick={handleManage} disabled={loading}>
            {loading ? 'Opening…' : 'Manage payment & invoices'}
          </Button>
        ) : null}
        {status === 'past_due' ? (
          <Alert variant="warning" className="mt-3 mb-0 small">
            Your last payment failed. Update your card via Manage payment to restore access.
          </Alert>
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionSettings;
